import Filters, { registerModuleFilters } from '@/utils/input/filters';
import { CoreEnums } from '@/utils/domain/constants';
import { createEnumOptions } from '@/utils/core/data-transformation';
import { getEnumNamespace } from '@/utils/infrastructure';

const { UserFilter, ProcessFilter, EnvironmentFilter, BaseFilters, DateFilter } = Filters;
const { DelegatedTaskStatus } = CoreEnums;

export const Status = {
  [DelegatedTaskStatus.Delegated]: {
    id: 'delegatedTasks.delegated',
    color: 'success',
  },
  [DelegatedTaskStatus.Deleted]: {
    id: 'delegatedTasks.deleted',
    color: 'voided',
  },
};

const DelegatedTaskStatusFilter = {
  ...BaseFilters.EnumFilter,
  name: 'status',
  label: 'global.text.status',
  enumNamespace: getEnumNamespace(DelegatedTaskStatus),
  enumSource: DelegatedTaskStatus,
  options: createEnumOptions(DelegatedTaskStatus, 'delegatedTasks'),
};

export const filtersConfig = [
  DateFilter,
  DelegatedTaskStatusFilter,
  EnvironmentFilter,
  ProcessFilter,
  { ...UserFilter, name: 'delegatedUserId', label: 'delegatedTasks.form.name' },
];

registerModuleFilters('delegatedTasks', filtersConfig);
